import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { inquiryScopeView } from "../../../utils/inquiryScope"
import { McPill } from "../../shared/McPill"

interface InquiryScopePillsProps {
  inquiry: Parameters<typeof inquiryScopeView>[0]
  /** Show at most this many regulation pills, the rest as one "+N" pill (a list row;
   *  pdf_and_excel can ask 8). Omitted: every regulation. */
  max?: number
}

/** The regulations an inquiry asks, one muted pill each (short label; full name on
 *  hover and for screen readers); a single muted pill for a draft following Settings
 *  or an inquiry sent before per-inquiry scopes; nothing when it asked no regulation. */
export function InquiryScopePills({ inquiry, max }: InquiryScopePillsProps) {
  const { translate } = useTranslation()
  const view = inquiryScopeView(inquiry, translate)

  if (view.kind === "none") return null
  if (view.kind === "orgDefault" || view.kind === "all") {
    return (
      <McPill tone="muted">
        {translate(
          view.kind === "all" ? "MC_INQ_SCOPE_ALL" : "MC_INQ_SCOPE_ORG_DEFAULT",
        )}
      </McPill>
    )
  }
  const shown =
    max === undefined ? view.regulations : view.regulations.slice(0, max)
  const hiddenNames = view.regulations
    .slice(shown.length)
    .map((regulation) => regulation.title)
    .join(", ")
  return (
    <>
      {shown.map((regulation) => (
        <McPill key={regulation.key} tone="muted" title={regulation.title}>
          {regulation.title === regulation.label ? (
            regulation.label
          ) : (
            <>
              <span aria-hidden="true">{regulation.label}</span>
              <span className="sr-only">{regulation.title}</span>
            </>
          )}
        </McPill>
      ))}
      {hiddenNames && (
        <McPill tone="muted" title={hiddenNames}>
          <span aria-hidden="true">
            +{view.regulations.length - shown.length}
          </span>
          <span className="sr-only">{hiddenNames}</span>
        </McPill>
      )}
    </>
  )
}
